import React from "react";
import { useNavigate } from "react-router-dom";
import { convertDateFormat } from "../../Utils/utils";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";

const EnergyAssetsCard = ({ plantData }) => {
  const { getText } = useLanguageTranslation();

  const navigate = useNavigate();
  return (
    <li>
      <article>
        <img
          src={`${process.env.REACT_APP_IMAGE_URL}/${plantData?.field_energy_assets_imgae}`}
          alt={plantData?.title}
        />
      </article>
      <aside>
        <h2>
          <b> {getText("Plant", "संयंत्र")} -</b>
          {plantData?.title?.slice(0, 41)}
        </h2>
        <h3>
          <b>{getText("Location", "स्थान")} -</b>
          {plantData?.field_location_assets}
        </h3>
        <h3>
          <b>{getText("Plant Size", "प्लांट साइज़")} -</b>
          {plantData?.field_plant_size}
        </h3>
        <h3>
          <b>{getText("Completion Date", "पूर्ण तिथि")} -</b>
          {convertDateFormat(plantData?.field_completed_date)}
        </h3>
        <div>
          <a
            className="quick-btn"
            href="#"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              navigate(
                `/power-generation/${plantData.field_category_page_assets
                  .split(" ")
                  .join("-")
                  .toLowerCase()}/${plantData.nid}`
              );
            }}
          >
            {getText("Read More", "अधिक जानकारी")}
          </a>
        </div>
      </aside>
    </li>
  );
};

export default EnergyAssetsCard;
